import { ITypedReduxAction } from '../../types/redux';

export enum EResultsActionType {
  SetDominantSubdomain = 'results/setDominantSubdomain',
  SetDominantRegionId = 'results/setDominantRegionId',
}

export type TSetDominantSubdomain = ITypedReduxAction<EResultsActionType.SetDominantSubdomain, string>;
export type TSetDominantRegionId = ITypedReduxAction<EResultsActionType.SetDominantRegionId, number | null>;

export type TResultsActions = TSetDominantSubdomain | TSetDominantRegionId;
